/**
 * Need to keep these names outside the component
 * for component type checking in SelectList
 * to avoid circular dependency issue Dropdown -> SelectList -> Dropdown
 */
export const DropdownItemDisplayName = 'DropdownItem';
export const DropdownItemGroupDisplayName = 'DropdownItemGroup';
